module.exports = __webpack_public_path__ + "static/womens-silver-7350d217fcad4a4ef047a36e9ab8d11f.jpg";